module.exports = function (getRestrictions, value) {
  var dictionaries = getRestrictions('dictionary');
  if (dictionaries.length && dictionaries.includes(value)) {
    throw {
      message: 'dictionary_not_found',
      params: { value: value }
    };
  }

  return value;
};
